import { PortfolioShareStatus } from "../../utProto/webEnums_pb";

export enum OrderStatus {
  confirmed = 'CONFIRMED',
  partially_filled = 'PARTIALLY FILLED',
  replaced = 'REPLACED',
  rms_reject = 'RMS REJECT',
  new_rejected = 'NEW REJECTED',
  replace_rejected = 'REPLACE REJECTED',
  cancel_rejected = 'CANCEL REJECTED',
  cancelled = 'CANCELLED',
  filled = 'FILLED',
  frozen = 'FROZEN',
  pending_new = 'PENDING NEW',
  pending_replace = 'PENDING REPLACE',
  pending_cancel = 'PENDING CANCEL',
  amo_pending = 'AMO PENDING',
  amo_replaced = 'AMO REPLACED',
  amo_cancelled = 'AMO CANCELLED',
  amo_rejected = 'AMO REJECT',
  amo_replace_rejected = 'AMO REPLACE REJECTED',
  amo_cancel_rejected = 'AMO CANCEL REJECTED'
}

export enum RouteMap {
  savedAlgo = '/trading/algo-tracking',
  createAlgo = '/trading/strategies/create',
  createSingleAlgo = '/trading/strategies/create-strategy',
  editBacktestAlgo = '/trading/backtest/detail/',
  books = '/trading/books',
  review = 'trading/my-strategies/portfolio-overview',
  // marketwatch is not implemented, commenting to make it inaccessible
  // marketWatch = '/trading/marketwatch',
  dashboard = '/trading/dashboard',
  completed = '/trading/algo-tracking?algoTab=1',
  personalDetails = '/trading/profile/user/personal-details',
  plans = '/trading/profile/user/plans',
  deployedSection = '/trading/my-strategies/',
  globalExit = '/trading/strategies/global-exit-settings',
  publishPortfolio = '/trading/creator-space/external-strategy',
  aiBacktest = '/trading/ai-backtest'
}

export enum ToastrIconType {
  success = 'check_circle',
  warning = 'warning',
  error = 'error_outline',
  info = 'check'
}

export enum DashboardDefaultStrategyType {
  ORIGINALS = 0,
  VERIFIED = 1
}


export const PortfolioShareStatusMap = {
  [PortfolioShareStatus.PORTFOLIOSHARESTATUS_ACCEPTED]: 'Accepted',
  [PortfolioShareStatus.PORTFOLIOSHARESTATUS_PENDING]: 'Pending',
  [PortfolioShareStatus.PORTFOLIOSHARESTATUS_REJECTED]: 'Rejected',
  [PortfolioShareStatus.PORTFOLIOSHARESTATUS_REVOKED]: 'Revoked'
};